import {Component, OnDestroy, OnInit} from '@angular/core';
import {ActivatedRoute} from "@angular/router";
import {environment} from "../../environments/environment";
import {MatSelectModule} from "@angular/material/select";
import {MatFormFieldModule} from "@angular/material/form-field";
import {BreadcrumbService} from "xng-breadcrumb";
import {Lightbox} from "@pierresh/ngx-lightbox";
import {AllViewItemService} from "./all-view-item.service";
import {ProductSingle} from "../productsingle/product-single";
import {Globals} from "../globals";
import {SeoService} from "../shared/seo.service";
import {ListingAttributeValueView} from '../shared/attribute-schema.service';
import {AppConfigService} from '../shared/app-config.service';

@Component({
  standalone: false,
  selector: 'app-all-view',
  templateUrl: './all-view-item.component.html',
  styleUrls: ['./all-view-item.css'],
  imports: [MatFormFieldModule, MatSelectModule]
})
export class AllViewItemComponent implements OnInit, OnDestroy {
  environment: any;
  isShow = true;
  id:string;
  photosTemp: any;
  itemSingle: any = new ProductSingle();
  photo: any = 'assets/images/cat-2.jpg';
  photos: any;
  imageSrc: any;
  url: any;
  listingAttributes: ListingAttributeValueView[] = [];

  slideConfig = {
    "slidesToShow" : 1,
    "slidesToScroll" : 1,
    "dots" : true,
    "infinite" : false,
    // "autoRotate" : true,
    // "autoRotateAfter" : 5000,
    "autoplay" : true,
    "autoplaySpeed" : 10000
  };

  constructor(private route:ActivatedRoute,
              private _lightbox: Lightbox,
              private breadcrumbService: BreadcrumbService,
              private allViewItemService: AllViewItemService,
              private seoService: SeoService,
              private appConfigService: AppConfigService,
              public globals: Globals) {

    environment.then(environment => {
      this.imageSrc = environment["images"];
      this.url = environment["backendURL"];
      this.environment = environment;
    });
  }

  ngOnInit(): void {
    this.id = this.route.snapshot.paramMap.get('id');
    this.globals.isView = true;
    const profile = this.globals.listingFilter.profile;
    this.allViewItemService.getItem(this.url, this.id, profile)
      .subscribe(response => {
        const payload: any = response;
        this.itemSingle = payload?.item || payload;
        this.appConfigService.attributesEnabled().subscribe(enabled => {
          this.listingAttributes = enabled ? (payload?.attributes || []) : [];
        });

        // console.log(this.itemSingle);
        this.breadcrumbService.set('@Car' ,this.itemSingle.name.toUpperCase());
        this.breadcrumbService.set('@Camper Van' ,this.itemSingle.name.toUpperCase());
        this.breadcrumbService.set('@Motor-bike' ,this.itemSingle.name.toUpperCase());
        this.breadcrumbService.set('@All Motors param' ,this.itemSingle.name.toUpperCase());
        this.breadcrumbService.set('@AllMotor' ,this.itemSingle.name.toUpperCase());
        this.breadcrumbService.set('@AllSport' ,this.itemSingle.name.toUpperCase());
        this.breadcrumbService.set('@AllTicket' ,this.itemSingle.name.toUpperCase());
        this.breadcrumbService.set('@sportevent' ,this.itemSingle.name.toUpperCase());
        this.breadcrumbService.set('@concert' ,this.itemSingle.name.toUpperCase());
        this.breadcrumbService.set('@festival' ,this.itemSingle.name.toUpperCase());
        this.breadcrumbService.set('@allProperty' ,this.itemSingle.name.toUpperCase());
        this.breadcrumbService.set('@propertyswap' ,this.itemSingle.name.toUpperCase());
        this.breadcrumbService.set('@rental' ,this.itemSingle.name.toUpperCase());
        this.breadcrumbService.set('@allTravel' ,this.itemSingle.name.toUpperCase());
        this.breadcrumbService.set('@weekendbreak' ,this.itemSingle.name.toUpperCase());
        this.breadcrumbService.set('@holiday' ,this.itemSingle.name.toUpperCase());
        this.breadcrumbService.set('@monitor' ,this.itemSingle.name.toUpperCase());
        this.breadcrumbService.set('@pc' ,this.itemSingle.name.toUpperCase());
        this.breadcrumbService.set('@gaming-pc' ,this.itemSingle.name.toUpperCase());
        this.breadcrumbService.set('@laptop' ,this.itemSingle.name.toUpperCase());
        this.breadcrumbService.set('@all-electronic' ,this.itemSingle.name.toUpperCase());
        this.breadcrumbService.set('@allsmartphone' ,this.itemSingle.name.toUpperCase());
        this.breadcrumbService.set('@android' ,this.itemSingle.name.toUpperCase());
        this.breadcrumbService.set('@ios' ,this.itemSingle.name.toUpperCase());
        this.breadcrumbService.set('@all-gaming' ,this.itemSingle.name.toUpperCase());
        this.breadcrumbService.set('@console' ,this.itemSingle.name.toUpperCase());
        this.breadcrumbService.set('@game' ,this.itemSingle.name.toUpperCase());
        this.breadcrumbService.set('@allMusic' ,this.itemSingle.name.toUpperCase());
        this.breadcrumbService.set('@record' ,this.itemSingle.name.toUpperCase());
        this.breadcrumbService.set('@radio' ,this.itemSingle.name.toUpperCase());
        this.breadcrumbService.set('@instrument' ,this.itemSingle.name.toUpperCase());
        this.breadcrumbService.set('@GymGear' ,this.itemSingle.name.toUpperCase());
        this.breadcrumbService.set('@GymEquipment' ,this.itemSingle.name.toUpperCase());
        this.breadcrumbService.set('@kitchen' ,this.itemSingle.name.toUpperCase());
        this.breadcrumbService.set('@furniture' ,this.itemSingle.name.toUpperCase());
        this.breadcrumbService.set('@bedroom' ,this.itemSingle.name.toUpperCase());
        this.breadcrumbService.set('@allwoman' ,this.itemSingle.name.toUpperCase());
        this.breadcrumbService.set('@jewellery' ,this.itemSingle.name.toUpperCase());
        this.breadcrumbService.set('@makeup' ,this.itemSingle.name.toUpperCase());
        this.breadcrumbService.set('@clothe' ,this.itemSingle.name.toUpperCase());
        this.breadcrumbService.set('@shoe' ,this.itemSingle.name.toUpperCase());
        this.getPhotos(this.itemSingle);
      });
  }

  private applySeo(item: any): void {
    if (!item?.name) {
      return;
    }
    const imageUrls = (this.photos || [])
      .map((p: any) => p?.image)
      .filter((u: string) => !!u);
    this.seoService.applyListingProduct({
      name: item.name,
      description: item.description,
      price: item.value,
      currency: 'EUR',
      status: item.status || 'PUBLISHED',
      imageUrls,
      pageUrl: window.location.href.split('?')[0],
      sellerName: item.account?.name || null,
      brand: item.make || item.account?.name || null
    });
  }

  private getPhotos(photo: any) {
    if (photo.photo) {
      this.photosTemp = photo.photo.split(";");
      this.photos = [];
      this.photosTemp.forEach(o => {
        if (o !== '') {
          let str = this.imageSrc + o;
          this.photos.push({'image': str});
          this.photo = this.photos[0];
        }
      });
      this.photosTemp = [];
      this.photos.forEach (o => {
        const src = o.image;
        const caption = 'Image ' + o.image + ' caption here';
        const thumb = o.image;
        const album = { src: src, caption: caption, thumb: thumb };
        this.photosTemp.push(album);
      });

      // console.log('test', this.photosTemp);
    }
    this.applySeo(photo);
  }
  open(index: number): void { // open lightbox
    this._lightbox.open(this.photosTemp, index);
  }

  close(): void { // close lightbox programmatically
    this._lightbox.close();
  }

  changeIsShow() {
    this.isShow = false;
    // console.log('isShow test', this.isShow);
  }

  ngOnDestroy(): void {
    this.globals.isView = false;
    this.seoService.clearListingProduct();
  }



}

